export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "Canara Bank Personal Loan EMI Calculator: Plan Your Finances Effectively",
    subHeading:
      "Use <strong>MinEMI’s Personal Loan EMI Calculator</strong> to estimate your monthly payments, understand the total repayment amount, and make informed borrowing decisions for <strong>Canara Bank Personal Loans</strong>.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
